import React from "react";
import PageHeader from "../../components/PagesComponents/UniversalComponents/PageHeader.component";
import NotificationCollapseContainer from "../../components/Notification/NotificationCollapseContainer.component";
import DateFormater from "../../Utils/DateFormater.utils";
import { Helmet } from "react-helmet";

const Body = ({ notificationData, renderNotifiCards }) => {
  return (
    <section className="flex-col align-start justify-start g-1">
      <PageHeader />
      <Helmet>
        <title>Notification</title>
      </Helmet>
      <hr color="#DCDBDB" />
      {notificationData.map((outerData, index) => {
        return (
          <NotificationCollapseContainer
            date={DateFormater(outerData?.date)}
            key={index}
          >
            {outerData?.entries.map((innerData, index) => {
              // console.log(innerData);

              return renderNotifiCards(innerData?.type.toString(), innerData);
            })}
          </NotificationCollapseContainer>
        );
      })}
    </section>
  );
};

export default Body;
